export default __webpack_public_path__ + "static/media/section4litmatch2.74a2c303.png";